// eslint-disable-next-line import/no-named-as-default
import gql from 'graphql-tag'
import { sectionReadMoreFields } from './sections/readMoreFragment.graphql'
import { sectionTextWithCtaFields } from './sections/textWithCtasFragment.graphql'
import { sectionUspFields } from './sections/uspFragment.graphql'
import { sectionFeatureFields } from './sections/featuresFragment.graphql'
import { sectionHomepageHeroFields } from './sections/homepageHerofragment.graphql'
import { buttonFields } from './elements/buttonFragment.graphql'

const homepageRedesignFields = gql`
  fragment homepageRedesignFields on HomepageRedesignRecord {
    hero {
      ...sectionHomepageHeroFields
    }
    carousel {
      title
      cta {
        ...buttonFields
      }
    }
    usp {
      ...sectionUspFields
    }
    features {
      ...sectionFeatureFields
    }
    beforeYouStart {
      ...sectionUspFields
    }
    about {
      ...sectionTextWithCtaFields
    }
    readMore {
      ...sectionReadMoreFields
    }
  }
  ${sectionHomepageHeroFields}
  ${sectionTextWithCtaFields}
  ${sectionReadMoreFields}
  ${sectionUspFields}
  ${sectionFeatureFields}
  ${buttonFields}
`

export const homeQuery = gql`
  query Home($locale: SiteLocale) {
    homepageRedesign(locale: $locale) {
      ...homepageRedesignFields
      seo: _seoMetaTags {
        tag
        attributes
        content
      }
    }
  }
  ${homepageRedesignFields}
`
